module.exports = __webpack_public_path__ + "img/planet1.4baa8beb.png";